module.exports = __webpack_public_path__ + "static/media/our_iuxlabs.0771adf8.png";